import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import styles from "./loader.module.css";

const Loader = ({ loading, background }) => {
  if (!loading) return null;

  return (
    <div
      className={styles.loaderOverlay}
      style={{ backgroundColor: background || "#FFF" }}
    >
      <div className={styles.loaderContainer}>
        <DotLottieReact
          src='https://lottie.host/4af113a6-4b44-4266-9742-fbc97d53c64c/y8KVt0EjyP.lottie'
          loop
          autoplay
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
};

export default Loader;
